export const ENTITY_COLOR_PALETTE = [
  '#35155A', // dark purple
  '#8661C1', // brand purple
  '#0F6B53', // dark green
  '#A66700', // ochre
  '#C7382F', // brick red
  '#1E5BAA', // deep blue
  '#6B4E9B', // muted violet
  '#0B5A4A', // forest teal
  '#4a7cf6', // blue
  '#e05690', // rose
  '#0ea5a0', // teal
  '#f97316', // orange
  '#7c3aed', // violet
  '#2e8b57', // sea green
  '#dc2626', // red
  '#0284c7', // sky blue
  '#a855f7', // purple
  '#b45309', // amber
  '#059669', // emerald
  '#be185d', // pink
  '#4f46e5', // indigo
  '#0891b2', // cyan
  '#9333ea', // deep purple
  '#c2410c', // burnt orange
  '#0d9488', // dark teal
  '#6d28d9', // grape
  '#1d4ed8', // royal blue
  '#b91c1c', // dark red
  '#047857', // forest green
  '#7e22ce', // plum
  '#ea580c', // tangerine
  '#6366f1', // periwinkle
  '#db2777', // magenta
  '#0e7490', // ocean
  '#15803d', // kelly green
  '#9f1239', // crimson
  '#1e40af', // navy
  '#7c2d12' // sienna
] as const;

export function getRouteItemColor(index: number) {
  return ENTITY_COLOR_PALETTE[index % ENTITY_COLOR_PALETTE.length];
}

const hashString = (value: string) =>
  Math.abs([...value].reduce((hash, char) => ((hash << 5) + hash + char.charCodeAt(0)) | 0, 5381));

export function getColorForName(name: string) {
  return ENTITY_COLOR_PALETTE[hashString(name) % ENTITY_COLOR_PALETTE.length]!;
}

/** Returns a readable text color (near-black or white) for a given hex background. */
export function getReadableTextColor(hex: string) {
  const r = Number.parseInt(hex.slice(1, 3), 16);
  const g = Number.parseInt(hex.slice(3, 5), 16);
  const b = Number.parseInt(hex.slice(5, 7), 16);
  // Perceived brightness (ITU-R BT.709)
  return r * 0.299 + g * 0.587 + b * 0.114 > 160 ? '#1e293b' : '#ffffff';
}
